function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#F9F7F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.8923 13.1692C14.8923 12.5692 15.3846 12.3385 16.2 12.3385C17.3692 12.3385 18.8462 12.6923 20.0154 13.3231V9.70769C18.7385 9.2 17.4769 9 16.2 9C13.0769 9 11 10.6308 11 13.3538C11 17.6 16.8462 16.9231 16.8462 18.7538C16.8462 19.4615 16.2308 19.6923 15.3692 19.6923C14.0923 19.6923 12.4615 19.1692 11.1692 18.4615V22.1231C12.6 22.7385 14.0462 23 15.3692 23C18.5692 23 20.7692 21.4154 20.7692 18.6615C20.7538 14.0769 14.8923 14.8923 14.8923 13.1692Z",
  fill: "#635BFF"
});

function SvgStripeBillingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeBillingIcon);
export default __webpack_public_path__ + "static/media/stripe-billing-icon.b7478e0b.svg";
export { ForwardRef as ReactComponent };